export type Language = "ar" | "en" | "zh" | "tr";
export type TranslationKey = string;

export const LANGUAGES: { code: Language; name: string; nativeName: string; dir: "rtl" | "ltr"; flag: string }[] = [
  { code: "ar", name: "Arabic", nativeName: "العربية", dir: "rtl", flag: "🇮🇶" },
  { code: "en", name: "English", nativeName: "English", dir: "ltr", flag: "🇺🇸" },
  { code: "zh", name: "Chinese", nativeName: "中文", dir: "ltr", flag: "🇨🇳" },
  { code: "tr", name: "Turkish", nativeName: "Türkçe", dir: "ltr", flag: "🇹🇷" },
];

import arTranslations from "./i18n/ar";

const loadedTranslations: Partial<Record<Language, Record<string, string>>> = {
  ar: arTranslations,
};

const loaders: Record<Language, () => Promise<{ default: Record<string, string> }>> = {
  ar: () => import("./i18n/ar"),
  en: () => import("./i18n/en"),
  zh: () => import("./i18n/zh"),
  tr: () => import("./i18n/tr"),
};

export async function loadLanguage(lang: Language): Promise<Record<string, string>> {
  if (loadedTranslations[lang]) return loadedTranslations[lang]!;
  const mod = await loaders[lang]();
  loadedTranslations[lang] = mod.default;
  return mod.default;
}

export function t(key: string, lang: Language): string {
  return loadedTranslations[lang]?.[key] || loadedTranslations["ar"]?.[key] || key;
}
